import styles from './ChartItemAdmissions.module.css';

//#region [Props]
type ChartItemAdmissionsProps = {
	label: string;
	value: number | string;
};
//#endregion

//#region [Component]
export default function ChartItemAdmissions({ label, value }: ChartItemAdmissionsProps) {
	return <span className={styles.SAdmissions}>
		<span className={styles.SDetailHeader}>{label}: </span>
		<span>{value.toLocaleString()}</span>
	</span>;
}
//#endregion
